// extracted by mini-css-extract-plugin
export default {"cardBoxContainer":"style_cardBoxContainer__nidku","cardBoxWrapper":"style_cardBoxWrapper__Q6hFO","cardTitle":"style_cardTitle__2nUzE","cardBody":"style_cardBody__iyR2b"};